import { add, substract } from '@yandex-int/ims.opaque-types/lib';
import { useCallback } from 'react';

import { usePlayerInstance } from '@/scenarios/legacy-player/lib/contexts/instance';

const SEEK_INTERVAL = 10;

export const useSeek = () => {
    const instance = usePlayerInstance();

    const seekBackward = useCallback(
        (seekInterval: number = SEEK_INTERVAL) => {
            const currentTime = instance?.currentTime;
            if (instance && currentTime !== undefined) {
                instance.seek(substract(currentTime, seekInterval));
            }
        },
        [instance]
    );

    const seekForward = useCallback(
        (seekInterval: number = SEEK_INTERVAL) => {
            const currentTime = instance?.currentTime;
            if (instance && currentTime !== undefined) {
                instance.seek(add(currentTime, seekInterval));
            }
        },
        [instance]
    );

    const seekToTime = useCallback(
        (time: number) => {
            const currentTime = instance?.currentTime;
            if (instance && currentTime !== undefined) {
                instance.seek(time);
            }
        },
        [instance]
    );

    return { seekBackward, seekForward, seekToTime };
};
